import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserStoreService } from '../../../core/services/user-store.service';
import { MatDialog } from '@angular/material';
import { ModalRegistroComponent } from '../modals/modal-registro/modal-registro.component';
import { Router } from '@angular/router';
import { ImagenesBannerService } from '../../../core/services/nuevaLogica/ecommerce/imagenes-banner.service';
import { ProductosService } from '../../../core/services/nuevaLogica/productos/productos.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  novedades: any;
  masVendidos: any = [];
  banners = {};
  isMobile;
  sliderConfig: any = {
    autoplay: true,
    autoplaySpeed: 4000,
  };
  time = 0;
  interval: any;

  bannersNovedades = [
    {
      img: 'https://nueva-logica.s3.us-east-2.amazonaws.com/banners/home-golden/CUADRADO-1.jpg',
      marca: 'yeezy'
    },
    {
      img: 'https://nueva-logica.s3.us-east-2.amazonaws.com/banners/home-golden/CUADRADO-2.jpg',
      marca: 'jordan'
    },
    {
      img: 'https://nueva-logica.s3.us-east-2.amazonaws.com/banners/home-golden/CUADRADO-3.jpg',
      marca: 'nike'
    },
    {
      img: 'https://nueva-logica.s3.us-east-2.amazonaws.com/banners/home-golden/CUADRADO-4.jpg',
      marca: 'adidas'
    },
  ]

  bannersBoxCenter = [
    {
      img: 'assets/images/golden/banners-nuevo/cuadrados/cuadrado1.jpg',
      marca: 'jordan'
    },
    {
      img: 'assets/images/golden/banners-nuevo/cuadrados/cuadrado2.jpg',
      marca: 'yeezy'
    },
    {
      img: 'assets/images/golden/banners-nuevo/cuadrados/cuadrado3.jpg',
      marca: 'nike'
    },
  ]
  constructor(
    private userService: UserStoreService,
    public dialog: MatDialog,
    private productosService: ProductosService,
    private imagenesBannerService: ImagenesBannerService,
    public router: Router
  ) {}

  ngOnInit() {
    this.isMobile =
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i);
    if (!sessionStorage.getItem('token')) {
      this.modalCupon();
      /*this.interval = setInterval(() => {
        if (this.time < 11 ) {
          this.time++;
        }
        if (this.time === 10) {
          this.modalCupon();
        }
      }, 1000);*/
    }
    this.getNovedades();
    this.getMasVendidos();
    this.getBanner();
  }

  ngOnDestroy(): void {
    this.interval = null;
  }

  modalCupon() {
    this.dialog.open(ModalRegistroComponent, {
      width: this.isMobile ? '80%' : '500px',
      height: this.isMobile ? '90%' : null,
    });
  }

  getNovedades() {
    this.productosService.getMasNuevos().subscribe((data) => (this.novedades = data));
  }

  getMasVendidos() {
    this.productosService.getMasVendidos().subscribe((data) => (this.masVendidos = data));
  }

  getBanner() {
    this.imagenesBannerService.getImagenes().subscribe((data) => {
      data.forEach((banner) => (this.banners[banner.nivel] = banner));
    });
  }
}
